import { render } from "./ButtonV2.vue?vue&type=template&id=8ea8362a&scoped=true"
import script from "./ButtonV2.vue?vue&type=script&lang=js"
export * from "./ButtonV2.vue?vue&type=script&lang=js"

import "./ButtonV2.vue?vue&type=style&index=0&id=8ea8362a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea8362a"]])

export default __exports__